module.exports = __webpack_public_path__ + "static/img/777.8dba8b26.png";